import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { platformBrowser } from '@angular/platform-browser';
import localePl from '@angular/common/locales/pl';

import moment from 'moment';
import 'moment/locale/pl.js';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { MAT_DATE_LOCALE } from '@angular/material/core';

// Register Polish locale
registerLocaleData(localePl);

// Set moment.js to use Polish locale globally

moment.locale('pl');

if (environment.production) {
  enableProdMode();
}


platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], providers: [{
      provide: MAT_DATE_LOCALE,
      useValue: 'pl'
    }] })
  .catch(err => console.error(err));

